import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";

import "css/admin/timeline.scss";
import TimelineArrow from "./TimelineArrow";
import TimelineItem from "./TimelineItem";
import TimelineLoader from "./TimelineLoader";

const SLIDER_SETTINGS = {
  speed: 500,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  nextArrow: <TimelineArrow direction="right" />,
  prevArrow: <TimelineArrow direction="left" />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function Timeline({ title, itemList, isLoading, emptyMessage }) {
  const renderItems = itemList?.map(
    ({
      uuid,
      item,
      onClick,
      cardPicture,
      cardTitle,
      durationString,
      dateString,
      timeString,
      label,
    }) => (
      <TimelineItem
        key={uuid}
        item={item}
        onClick={onClick}
        cardPicture={cardPicture}
        cardTitle={cardTitle}
        durationString={durationString}
        dateString={dateString}
        label={label}
        timeString={timeString}
      />
    ),
  );

  const isEmpty = !isLoading && itemList?.length === 0;

  return (
    <div className="timeline-container">
      <div className="timeline-title">{title}</div>
      {isEmpty ? (
        <div className="timeline-empty">{emptyMessage}</div>
      ) : isLoading ? (
        <TimelineLoader />
      ) : (
        <Slider {...SLIDER_SETTINGS}>{renderItems}</Slider>
      )}
    </div>
  );
}

Timeline.propTypes = {
  title: PropTypes.string.isRequired,
  itemList: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      item: PropTypes.object.isRequired,
      onClick: PropTypes.func.isRequired,
      cardPicture: PropTypes.string.isRequired,
      cardTitle: PropTypes.string.isRequired,
      durationString: PropTypes.string.isRequired,
      dateString: PropTypes.string.isRequired,
      timeString: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
  emptyMessage: PropTypes.string,
};

Timeline.defaultProps = {
  emptyMessage: "No items to display",
  isLoading: false,
};

export default Timeline;
